import apiConstents from "views/eywafarm/CropCycle/utils/constent"
import ApiService from "./ApiService"
export async function apiGetPartnerList(params) {
    return ApiService.fetchData({
        url: `cropcycle/partners`,
        method: 'get',
        // params
    })
}

export async function apiGetPartnerCropsList(id) {
    return ApiService.fetchData({
        url: `partners/${id}`,
        method: 'get',
        // params
    })
}

export async function apiCropCyclesList(query) {
    return ApiService.fetchData({
        url: `crop-cycles?${apiConstents.cropCyclesPopulate}&${apiConstents.allDataLimit}${apiConstents.fileterUser2}${query}`,
        method: 'get'
    })
}

export async function apiCreateCropCycle(data) {
    return ApiService.fetchData({
        url: `cropcycle/save/corpconnects`,
        method: 'post',
        data
    })
}

export async function apiUpdateCropCycle(id, data){
    return ApiService.fetchData({
        url: `crop-cycles/${id}`,
        method: 'put',
        data
    })
}